import {Badge} from '@mantine/core';

import {ProviderConnection} from '../types';
import {
    presentStatus,
    statusColor,
} from '../statusPresentation';

// FNP-1248 — the status badge.
//
// Its own file because a module that also exports a hook or a constant breaks
// Fast Refresh, and this repo lints at --max-warnings 0. The library has no
// status-badge export, so this is a local Mantine `Badge` — the same call the
// zones module made for DelegationBadge.
//
// ⚠️ RENDERS FOUR TONES, NOT THREE. The status enum has three values but the
// module presents four states, because a first-time ASSUMED_ROLE connection
// awaiting its trust policy is INVALID/UNREACHABLE in the schema and something
// entirely different to a tenant. `presentStatus` owns that distinction; this
// component never branches on `connection.status` itself.
export const ConnectionStatusBadge = (
    {connection}: { connection: ProviderConnection },
) => {

    const presentation = presentStatus(connection);

    return (
        <Badge
            variant={'light'}
            color={statusColor(presentation.tone)}
        >
            {presentation.label}
        </Badge>
    );
};
